// Utility to proxy HTTP images through our backend to avoid mixed content issues
export function proxyImageUrl(url) {
  if (!url) return null;
  
  // If already HTTPS or data URL, return as-is
  if (url.startsWith('https://') || url.startsWith('data:')) {
    return url;
  }
  
  // If HTTP, proxy through backend
  if (url.startsWith('http://')) {
    const backendUrl = process.env.REACT_APP_BACKEND_URL || '';
    return `${backendUrl}/api/proxy-image?url=${encodeURIComponent(url)}`;
  }
  
  return url;
}
